export default function LoginScreen({ onLogin, error }) {
  return (
    <div className="h-screen bg-[#1a1a1a] flex items-center justify-center">
      <div className="bg-[#161616] border border-[#2a2a2a] rounded-xl p-10 flex flex-col items-center gap-6 w-80">
        {/* Avatar */}
        <div className="w-16 h-16 rounded-full border-2 border-[#CC5500] bg-[#2a2a2a] flex items-center justify-center text-2xl font-bold text-[#CC5500]">
          T
        </div>
        <div className="text-center">
          <h1 className="text-white text-xl font-bold tracking-[0.25em]">TEGAN</h1>
          <p className="text-[#555] text-xs mt-1">Personal AI Assistant</p>
        </div>
        {error && (
          <p className="text-[#f87171] text-xs text-center bg-[#2a1a1a] border border-[#4a1a1a] rounded px-3 py-2 w-full">
            {error}
          </p>
        )}
        <button
          onClick={onLogin}
          className="w-full bg-[#CC5500] hover:bg-[#aa4400] text-white font-medium rounded px-4 py-2.5 text-sm transition-colors flex items-center justify-center gap-2"
        >
          <svg width="16" height="16" viewBox="0 0 48 48">
            <path fill="#FFF" d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-21 0-1.3-.2-2.7-.5-4z"/>
          </svg>
          Sign in with Google
        </button>
      </div>
    </div>
  );
}
